import { Box, Grid2, Typography } from "@mui/material";
import OneInfoCard from "../ui/OneInfoCard";
import { useEffect, useState, useContext } from "react";
import { AttachMoneyRounded, EventRounded, LocalActivityRounded } from "@mui/icons-material";
import { Context } from "../../App";
import moment from "moment";
import 'moment/locale/fr'; // Import French locale for moment.js

export default function FastBoldInfoSection() {
    const { setIsConnected } = useContext(Context);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const [loading, setLoading] = useState(true);
    const [billetsSold, setBilletsSold] = useState(0);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [nextEvent, setNextEvent] = useState();

    const size = { xs: 12, md: 4, lg: 4 };

    function getBilletsSold() {
        const query = user.role === 'super admin' ? {statut:{$in: ['valide','validé']}} : {statut:{$in: ['valide','validé']}, event: {$in: user.events || []}};

        fetch(`${process.env.REACT_APP_API_URL}/billets/count`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: JSON.stringify(query)
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setBilletsSold(json.count);
                }
            }
        }).catch(error => {
            console.error("Error fetching billets sold:", error);
        }).finally(() => {
            setLoading(false);
        });
    }

    function getTotalRevenue() {
        const query = user.role === 'super admin' ? {statut:{$in: ['valide','validé']}} : {statut:{$in: ['valide','validé']}, event: {$in: user.events || []}};

        fetch(`${process.env.REACT_APP_API_URL}/billets/somme`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: JSON.stringify(query)
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setTotalRevenue(json.total);
                }
            }
        }).catch(error => {
            console.error("Error fetching total revenue:", error);
        }).finally(() => {
            setLoading(false);
        });
    }

    function getNextEvent() {
        const query = new URLSearchParams(user.role==='super admin' ? {} : {events: user.events}).toString();

        fetch(`${process.env.REACT_APP_API_URL}/adm/events/next?${query}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setNextEvent(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching next event:", error);
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(()=> {
        getBilletsSold();
        getTotalRevenue();
        getNextEvent();
    }, [])

    return(
        <Grid2 container spacing={2} sx={{ mb: 2 }}>
            <Grid2 size={size}>
                <OneInfoCard item={{
                    icon: <Box sx={{display:'inline-flex', backgroundColor: 'rgba(188, 121, 226, 0.2)', padding:1.3, borderRadius:2}}><LocalActivityRounded sx={{ color: '#bc79e2', fontSize: '32px' }} /></Box>,
                    label: "Billets vendus",
                    data: <Typography variant="body1" sx={{ textAlign:'center', fontWeight:'bold', color: 'black', fontSize: 28 }}>{billetsSold}</Typography>
                }} />
            </Grid2>
            <Grid2 size={size}>
                <OneInfoCard item={{
                    icon: <Box sx={{display:'inline-flex', backgroundColor: 'rgba(76, 175, 80, 0.2)', padding:1.3, borderRadius:2}}><AttachMoneyRounded sx={{ color: '#4caf50', fontSize: '32px' }} /></Box>,
                    label: "Recettes totales",
                    data: user.role==='super admin' ? <Typography variant="body1" sx={{ textAlign:'center', fontWeight:'bold', color: 'black', fontSize: 28, lineHeight: 1.2 }}>
                        {totalRevenue.toFixed(2)} €<br />
                        <span style={{fontSize: 16, fontWeight: 400}}>Frais (3%) : {Math.round(totalRevenue * 3)/100} €</span>
                    </Typography> :
                    <Typography variant="body1" sx={{ textAlign:'center', fontWeight:'bold', color: 'black', fontSize: 28, lineHeight: 0.8 }}>
                        {(totalRevenue-(Math.round(totalRevenue * 3)/100)).toFixed(2)} €<br />
                        <span style={{fontSize: 12, fontWeight: 400}}>Frais déduits (3%)</span>
                    </Typography>
                }} />
            </Grid2>
            <Grid2 size={size}>
                <OneInfoCard item={{
                    icon: <Box sx={{display:'inline-flex', backgroundColor: 'rgba(33, 150, 243, 0.2)', padding:1.3, borderRadius:2}}><EventRounded sx={{ color: '#2196f3', fontSize: '32px' }} /></Box>,
                    label: "Prochain événement",
                    data: <Typography variant="body1" sx={{ textAlign:'center', fontWeight:'bold', color: 'black', fontSize: 18 }}>
                        {!!nextEvent ? nextEvent.titre : 'Aucun événement futur'}<br />
                        <span style={{fontSize: 16, fontWeight: 400}}>{!!nextEvent ? moment.utc(nextEvent.date).locale('fr').format('LL') : null}</span>
                    </Typography>
                }} />
            </Grid2>
        </Grid2>
    )
}